import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  changeResponseFormatAction,
  deleteAssistantFunctionAction,
  getAssistantFunctionsAction,
  getAssistantMessagesAction,
  getAssistantSkillsAction,
  migrationAssistantVersionToNewApiAction,
  postMessageToAssistantAction,
  postMessageWithResponsesAction,
  uploadFileToAssistantDialogAction,
} from "./actions";
import type { AssistantsState } from "./types";

export function migrationAssistantVersionToNewApiReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(migrationAssistantVersionToNewApiAction.pending, (state) => {
    state.isServiceLoading = true;
  });
  builder.addCase(
    migrationAssistantVersionToNewApiAction.fulfilled,
    (state, action) => {
      if (!action.payload) return;
      state.assistantValue = action.payload;
      state.isServiceLoading = false;
    },
  );
  builder.addCase(migrationAssistantVersionToNewApiAction.rejected, (state) => {
    state.isServiceLoading = false;
  });
}

export function getAssistantFunctionsReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(getAssistantFunctionsAction.pending, (state) => {
    state.isFunctionsLoading = true;
  });
  builder.addCase(getAssistantFunctionsAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.assistantFunctions = action.payload?.map((item) => ({
      ...item,
      is_deletable: item?.is_deletable ?? false,
    }));
    state.isFunctionsLoading = false;
  });
  builder.addCase(getAssistantFunctionsAction.rejected, (state) => {
    state.isFunctionsLoading = false;
  });
}

export function postMessageToAssistantReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(postMessageToAssistantAction.pending, (state, action) => {
    const id = action.meta.arg;
    state.messageLoadingInfo[id] = true;
  });
  builder.addCase(postMessageToAssistantAction.fulfilled, (state, action) => {
    const id = action.meta.arg;
    if (!action.payload) return;
    state.messages = action.payload;
    state.messageLoadingInfo[id] = false;
  });
  builder.addCase(postMessageToAssistantAction.rejected, (state, action) => {
    const id = action.meta.arg;
    state.messageLoadingInfo[id] = true;
  });
}

export function postMessageWithResponsesReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(postMessageWithResponsesAction.pending, (state, action) => {
    const { id } = action.meta.arg;
    state.messageLoadingInfo[id] = true;
  });
  builder.addCase(postMessageWithResponsesAction.fulfilled, (state, action) => {
    const { id } = action.meta.arg;
    if (!action.payload) return;
    state.messages = action.payload;
    state.messageLoadingInfo[id] = false;
  });
  builder.addCase(postMessageWithResponsesAction.rejected, (state, action) => {
    const { id } = action.meta.arg;
    state.messageLoadingInfo[id] = false;
  });
}

export function getAssistantMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(getAssistantMessagesAction.pending, (state, action) => {
    const { id } = action.meta.arg;
    state.messageLoadingInfo[id] = true;
  });
  builder.addCase(getAssistantMessagesAction.fulfilled, (state, action) => {
    const { id } = action.meta.arg;
    if (!action.payload) return;
    state.messages = action.payload;
    state.messageLoadingInfo[id] = false;
  });
  builder.addCase(getAssistantMessagesAction.rejected, (state, action) => {
    const { id } = action.meta.arg;
    state.messageLoadingInfo[id] = false;
  });
}

export function deleteAssistantFunctionsReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(deleteAssistantFunctionAction.pending, (state) => {
    state.isFunctionsLoading = true;
  });
  builder.addCase(deleteAssistantFunctionAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.assistantFunctions = action.payload;
    state.isFunctionsLoading = false;
  });
  builder.addCase(deleteAssistantFunctionAction.rejected, (state) => {
    state.isFunctionsLoading = false;
  });
}

export function getAssistantSkillsReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(getAssistantSkillsAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.skills = action.payload;
  });
}

export function uploadFileToAssistantDialogReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(uploadFileToAssistantDialogAction.pending, (state) => {
    state.isFileLoading = true;
  });
  builder.addCase(uploadFileToAssistantDialogAction.fulfilled, (state) => {
    state.isFileLoading = false;
  });
  builder.addCase(uploadFileToAssistantDialogAction.rejected, (state) => {
    state.isFileLoading = false;
  });
}

export function changeResponseFormatReducerBuilder(
  builder: ActionReducerMapBuilder<AssistantsState>,
) {
  builder.addCase(changeResponseFormatAction.pending, (state) => {
    state.isServiceLoading = true;
  });
  builder.addCase(changeResponseFormatAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.assistantValue = action.payload;
    state.isServiceLoading = false;
  });
  builder.addCase(changeResponseFormatAction.rejected, (state) => {
    state.isServiceLoading = false;
  });
}
